import axios from 'axios';
import api from './ManageCalculationsReq';

export default axios.create({
    baseURL: `${api.defaults.baseURL}jetson/`
});